const stats = [
  { number: '50+', label: 'Projets Réalisés', icon: 'ri-building-line' },
  { number: '98%', label: 'Clients Satisfaits', icon: 'ri-emotion-happy-line' },
  { number: '5 ans', label: 'D\'Expérience', icon: 'ri-award-line' },
  { number: '4.9/5', label: 'Note Moyenne', icon: 'ri-star-fill' }
];

const StatsSection = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center text-white">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-5xl`}></i>
              </div>
              <div className="text-4xl md:text-5xl font-bold mb-2">{stat.number}</div>
              <div className="text-lg font-light opacity-90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
